import styles from './InputRadio.module.scss';

type Props = {
  name: string;
  inputValue: string;
  checked?: boolean;
  onChange: (e: React.ChangeEvent) => void;
  children?: React.ReactNode;
  inputRef?: React.Ref<HTMLInputElement>;
};

function InputRadio({ name, inputValue, checked = false, onChange, inputRef, children }: Props) {
  return (
    <label key={inputValue} className={styles.inputRadio}>
      <input
        type='radio'
        name={name}
        ref={inputRef}
        value={inputValue}
        checked={checked}
        onChange={(e) => onChange(e)}
        className={checked ? styles.manualChecked : ''}
      />
      <span className={styles.childText}>{children}</span>
    </label>
  );
}

export default InputRadio;
